import { useTranslation } from 'react-i18next';

export default function LoadCardBody(
    props: Readonly<{ showReason: boolean; reasonMessage: string | undefined }>,
) {
    const { showReason, reasonMessage } = props;

    const { t } = useTranslation();

    return (
        <div
            className="card-loads-body__suspension-info"
            style={{
                visibility: showReason ? 'visible' : 'hidden',
            }}
            data-testid="card-loads-body__suspension-info"
        >
            <span className="card-loads-body__suspension-label">
                {t('Motivo')}:
            </span>
            <span
                className="card-loads-body__suspension-message"
                data-testid="card-loads-body__suspension-message"
            >
                {reasonMessage}
            </span>
        </div>
    );
}
